/**
 * @file paddle pilot growth
 * @author wanzhongyun
 */

import { RightOutlined } from '@ant-design/icons';
import React from 'react';
import { IPilotGrowth } from './../../type';

import './style.less';


const PilotGrowth: React.FC<IPilotGrowth> = props => {

    const { title, rightsList, allCourceWord, allCourceLink } = props;

    return (
        <div className='paddle-pilot-growth-wrapper'>
            <div id='growthResource' className='paddle-pilot-anchor' />
            <div className='paddle-pilot-growth-title'>{ title }</div>
            <div className='paddle-pilot-growth-card-wrapper'>
                {
                    rightsList.map(item => <div className='paddle-pilot-growth-card' key={item.title}>
                        <div className='growth-card-title'>{ item.title }</div>
                        <div className='growth-card-item-wrapper'>
                            {
                                item.list.map(ele => <a href={ele.courceLink} target='_blank' rel='noreferrer'><div className='growth-card-item' key={ele.cource}>{ ele.cource }</div></a>)
                            }
                        </div>
                    </div>)
                }
            </div>
            <div className='paddle-pilot-growth-detail-link'>
                <a href={allCourceLink} target='_blank' rel="noreferrer" >
                    { allCourceWord }<RightOutlined className='paddle-pilot-growth-detail-link-icon' />
                </a>
            </div>
        </div>
    );
};

export default PilotGrowth;